export default [
  {

    title: "Chatbot-Ul Victor Isi Extinde Suportul Si Pentru Clientii Up Romania",
    link: "https://companie.upromania.ro/media/ultimele-noutati/up-permite-plata-tazz/",
    date: "06/06/2022",
  },
  {
    title: "Schimbari Legislative Aplicabile Biletelor De Valoare Emise De Up Romania Din 2022",
    link: "https://companie.upromania.ro/media/ultimele-noutati/up-permite-plata-tazz/",
    date: "08/06/2022",
  },
];
